import styled from 'styled-components';

import SparkleIcon from '@/assets/icons/SparkleIcon';
import { Flex } from '@/components/base';
import type { CHART_FIELD } from '@/entities/chart/model/constants';
import { useFeedbackTerminology } from '@/entities/workspace';
import { getChartFieldLabel } from '@/features/(charts)/chart-renderer/model/chart-maps';
import useColor from '@/hooks/domain/useColor';
import { radius } from '@/styles/sizes';

type Props = {
  field: CHART_FIELD;
  onClick: () => void;
};

export default function DimensionTopLabel({ field, onClick }: Props) {
  const color = useColor();
  const { replaceFeedbackTerminology } = useFeedbackTerminology();

  return (
    <TopLabelStyle
      onClick={onClick}
      a="center"
      g={4}
      className="text-sm font-semibold"
    >
      <SparkleIcon fill={color.yellow500} />
      Top {replaceFeedbackTerminology(getChartFieldLabel(field))}
    </TopLabelStyle>
  );
}

const TopLabelStyle = styled(Flex)`
  flex: 1;
  padding: 4px;
  background-color: ${(props) => props.theme.colors.gray100};
  border-radius: ${radius.token.lg}px;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.gray250};
  }
`;
